import { render, staticRenderFns } from "./EventRoomContentElementVideoModal.vue?vue&type=template&id=e6b581c4&"
import script from "./EventRoomContentElementVideoModal.vue?vue&type=script&lang=js&"
export * from "./EventRoomContentElementVideoModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDialog } from 'vuetify/lib/components/VDialog';
installComponents(component, {VDialog})
